import { Title } from "../types/tasks";

/**
 * Extracts the localized title string from a Title object based on the specified language
 * @param title - The multilingual Title object
 * @param language - The language code ('pt', 'en', 'es')
 * @returns The localized title string, or English as fallback
 */
export const getLocalizedTitle = (title: Title, language: string): string => {
  const lang = language.toLowerCase();

  if (lang === "pt" && title.pt) {
    return title.pt;
  }
  if (lang === "es" && title.es) {
    return title.es;
  }

  return title.en || "";
};
